module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"backBtn":"Back to Dashboard","settings":"Settings","logout":"Log out"},"zh":{"backBtn":"返回儀表板","settings":"设置","logout":"登出"},"kr":{"backBtn":"대시보드로 돌아가기","settings":"설정","logout":"로그 아웃"}}')
  delete Component.options._Ctor
}
